export const Country = {
  PL: 'pologne',
  MU: 'maurice',
  FR: 'france',
  CH: 'suisse',
} as const;

export type Country = (typeof Country)[keyof typeof Country];
